import script from "./MinistryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MinistryPage.vue?vue&type=script&setup=true&lang=js"

import "./MinistryPage.vue?vue&type=style&index=0&id=feeaed46&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-feeaed46"]])

export default __exports__